import { useState, useEffect } from 'react'
import api from '../services/api'

export default function Companies() {
  const [companies, setCompanies] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ name: '', email: '', phone: '', industry: '' })

  useEffect(() => {
    api.get('/companies').then(r => setCompanies(r.data))
  }, [])

  const handleCreate = async () => {
    if (!form.name) return
    const { data } = await api.post('/companies', form)
    setCompanies(prev => [data, ...prev])
    setForm({ name: '', email: '', phone: '', industry: '' })
    setShowForm(false)
  }

  const handleDelete = async (id) => {
    await api.delete(`/companies/${id}`)
    setCompanies(prev => prev.filter(c => c.id !== id))
  }

  const inputClass = "w-full bg-gray-800 rounded-lg px-3 py-2 mb-3 text-sm outline-none focus:ring-2 ring-indigo-500"

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Empresas</h1>
        <button onClick={() => setShowForm(true)} className="bg-indigo-600 hover:bg-indigo-700 px-4 py-2 rounded-lg text-sm font-semibold transition">
          + Nova Empresa
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-gray-900 rounded-xl p-6 w-full max-w-md border border-gray-700">
            <h2 className="text-lg font-bold mb-4">Nova Empresa</h2>
            <input className={inputClass} placeholder="Nome *" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            <input className={inputClass} placeholder="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            <input className={inputClass} placeholder="Telefone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            <input className={inputClass} placeholder="Segmento" value={form.industry} onChange={e => setForm({ ...form, industry: e.target.value })} />
            <div className="flex gap-2">
              <button onClick={handleCreate} className="flex-1 bg-indigo-600 hover:bg-indigo-700 py-2 rounded-lg text-sm font-semibold transition">Criar</button>
              <button onClick={() => setShowForm(false)} className="flex-1 bg-gray-700 hover:bg-gray-600 py-2 rounded-lg text-sm transition">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {companies.map(c => (
          <div key={c.id} className="bg-gray-900 rounded-xl p-4 border border-gray-800 hover:border-indigo-500/50 transition">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold">{c.name}</h3>
                {c.industry && <span className="text-xs text-indigo-400 bg-indigo-900/30 px-2 py-0.5 rounded-full mt-1 inline-block">{c.industry}</span>}
              </div>
              <button onClick={() => handleDelete(c.id)} className="text-gray-600 hover:text-red-400 transition text-sm">✕</button>
            </div>
            {c.email && <p className="text-gray-400 text-sm mt-2">📧 {c.email}</p>}
            {c.phone && <p className="text-gray-400 text-sm">📞 {c.phone}</p>}
          </div>
        ))}
        {companies.length === 0 && (
          <p className="text-gray-500 col-span-3 text-center py-12">Nenhuma empresa cadastrada ainda.</p>
        )}
      </div>
    </div>
  )
}